export enum PageTypes {
  AccountPages = "account-pages",
  Dashboard = "dashboard",
}
